import { Swiper, Navigation, Pagination } from 'swiper';

// Wellness pages set data-layout="wellness-layout" on <html> server-side (see
// layout/theme.wellness.liquid) — this is reliable regardless of how a slide's markup was
// produced, unlike template.suffix/product.template_suffix inside the section itself, which
// don't reflect the real page when this section is re-rendered via Shopify's recommendations
// AJAX endpoint. product-grid-item.liquid renders every candidate unconditionally here
// (skip_wellness_check) and exposes data-product-type, so we filter client-side instead.
const isWellnessPage = () => document.documentElement.getAttribute('data-layout') === 'wellness-layout';

const filterSlidesForWellness = (container) => {
    const wellnessPage = isWellnessPage();
    container.querySelectorAll('.swiper-slide').forEach((slide) => {
        const tile = slide.querySelector('.product-grid-item[data-product-type]');
        if (!tile) return;
        const isWellnessProduct = tile.dataset.productType.includes('Wellness');
        if (isWellnessProduct !== wellnessPage) {
            slide.remove();
        }
    });
}

export default ProductRecommendations = () => {
    const initSwiper = () => {
        Swiper.use(Navigation, Pagination);
        const recommendedProductCarousel = document.querySelectorAll('.product-section-recommendations .swiper').forEach(carousel => {
            const container = carousel.closest( 'section');
            const nextEl = container.querySelector('.swiper-button-next');
            const prevEl = container.querySelector('.swiper-button-prev');
            const swiper = new Swiper(carousel, {
                direction: 'horizontal',
                slidesPerView: 1.2,
                spaceBetween: 16,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.8,
                    },
                    768: {
                        slidesPerView: 2.2,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                }
            });
        })
    }

    const init = () => {
        const productRecommendationsSection = document.querySelectorAll('.product-section-recommendations .product-section-recommendations__inner');
        productRecommendationsSection.forEach(section => {
            // The section's own initial (server-rendered) slides also need filtering, since
            // product-grid-item.liquid renders every candidate unconditionally here.
            filterSlidesForWellness(section);

            let productId = section.dataset.productId;
            let limit = section.dataset.limit;
            let min = section.dataset.minrecommendations;
            fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=product-recommendations&intent=related")
            .then(response => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                filterSlidesForWellness(html);

                if (html.querySelectorAll('.swiper-slide').length > min) {
                    const recommendations = html.querySelector('.swiper');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        const recommendedPlaceholders = section.querySelector('.swiper');
                        recommendedPlaceholders.innerHTML = recommendations.innerHTML;
                        initSwiper();
                    }
                } else {
                    initSwiper();
                }
            });
        });
    }

    // For shopify customizer/editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            init();
        }
    });

    init();
}